import { render, staticRenderFns } from "./PaymentProductInfo.vue?vue&type=template&id=bd15c35a&scoped=true&"
import script from "./PaymentProductInfo.vue?vue&type=script&lang=js&"
export * from "./PaymentProductInfo.vue?vue&type=script&lang=js&"
import style0 from "./PaymentProductInfo.vue?vue&type=style&index=0&id=bd15c35a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd15c35a",
  null
  
)

export default component.exports